/**
 * InfiniteScroll handler.
 */
function infiniteScroll() {

	const categoryClass = '.school-link';
	const $container = setContainer();
	var page = 2;
	var max_pages = IntegracaoFilter.max_pages;
	var posts_per_page = IntegracaoFilter.posts_per_page;
	var loading = false;
	var $isAllProductVisible = isAllProductsVisible($container);

	// Filters

	$( '.school-links' ).on( 'click', categoryClass, toggleSelection );
	$( '.school-links' ).on( 'click', categoryClass, filterContent );
	$( '#btn-filters' ).on( 'click', filterContent );
	// Child menu item
	$( '.dropdown-menu.second-level' ).on( 'click', '.nav-link', targetFilter );

	// InfiniteScroll gate
	//prevents bugging infintescroll behavior in consultants and search results components
	if (!$(document).find('body').hasClass('tax-product_cat')) {
		$(window).scroll(infiniteLoading);
	}
	else {
		var $currentPage = 1;
		//activates only on scroll down
		window.onscroll = function(e) {
			// print "false" if direction is down and "true" if up
			if(this.oldScroll < this.scrollY){
				infiniteScrollTrigger();
			}
			this.oldScroll = this.scrollY;
		}
	}
	/**
	 * Check if there's a different container or instead use .products
	 *
	 * @return {string}   Container selector.
	 */
	function setContainer() {
		return $( '[data-filter="container"]' ).length ? $( '[data-filter="container"]' ) : $( '.products' );
	}

	/**
	 * Toggle selected filter elements
	 */
	function toggleSelection(e) {
		e.preventDefault();
		$( e.target ).toggleClass( 'active' );

		// scroll to top of container
		var scrollTo = '';

		if($('.banner-section').length) {
			// product page with slide
			scrollTo = $('.shop-wrapper').offset().top - 150;
		} else if ($('.header-banner').length) {
			// consultant list with header-banner
			scrollTo = $('.section-consultants').offset().top - 200;
		} else {
			// nothing found, scroll to top of body
			scrollTo = $('body').offset().top;
		}

		$('html, body').animate({
			scrollTop: scrollTo
		}, 1000);
	}

	/**
	 * Function to treat filter by nav links
	 */
	function targetFilter(e) {
		var filterTarget = $(e.target).data('filter-target');
		
		if( typeof filterTarget !== typeof undefined && filterTarget !== false ) {
			var $filterItem = $('[data-slug='+filterTarget+']');
			
			if( $filterItem.length ) {
				e.stopPropagation();
				e.preventDefault();
				
				$filterItem.click();
			}
		}
	}

	/**
	 * Run AJAX request to filter consultants.
	 */
	function filterContent() {
		if($('body').hasClass('modal-open')) {
			if($(this).hasClass('btn-dark')){
			page = 1;
			fetchResults( getSelectedCategories(), getSelectedTypeProdutos(), true );
			}
		} else {
			page = 1;
			fetchResults( getSelectedCategories(), getSelectedTypeProdutos(), true );
		}	
	}

	/**
	 * Get all selected categories.
	 * @return {array} Selected categories.
	 */
	function getSelectedCategories() {
		let categories = [];
		$( categoryClass + '.active' ).each(function(){
				categories.push( $( this ).data( 'slug' ) );
		});

		return categories;
	}

		/**
	 * Get all selected type produtos.
	 * @return {array} Selected type produtos.
	 */
	function getSelectedTypeProdutos() {
		let types = [];
		$( '.type-product' + '.active' ).each(function(){
				types.push( $( this ).data( 'typeid' ) );
		});
		return types;
	}

	/**
	 * InfiniteScroll check and trigger.
	 * @param  {[type]} event [description]
	 */

	function infiniteLoading( event ) {
		if ( page > max_pages ) {
			return;
		}

		if($('.not-found').length != 0){
			return;
		}

		var top_pos = $( window ).scrollTop();
		var bottom_container = $( $container ).height() + $( $container ).position().top;

		if ( ! loading && top_pos + 500 > bottom_container ) {
			loading = true;
			fetchResults( getSelectedCategories(), getSelectedTypeProdutos() );
		}
	}

	function infiniteScrollTrigger(event) {

		if ($('.not-found').length != 0) {
			return;
		}

		var top_pos = $(window).scrollTop();
		var bottom_container = $($container).height() + $($container).position().top;

		if ((top_pos + 850) > bottom_container) {
			//adds 1 to maxpage because starts on 0
			var $maxPages = parseInt($('#max_pages').val()) + 1;
			if ($currentPage < $maxPages) {
				if (!loading) {
					if (!$isAllProductVisible) {
						$($container).prepend('<div class="loader fixed"><div class="box1"></div><div class="box2"></div><div class="box3"></div></div>');
						loading = true;
						setTimeout(function () {
							showNextResults($currentPage);
						}, 500);
					}
				}
			} else {
				$('#currentPage').val(1);
				$currentPage = 1;
			}
		}
	}

	function showNextResults(page) {
		$('.loader').remove();
		loading = false;
		$('.product-card[data-page="' + ($currentPage + 1) + '"]').fadeIn('slow');
		$('#currentPage').val($currentPage++);
		$isAllProductVisible = isAllProductsVisible($container);
	}

	function isAllProductsVisible(container) {
		result = [];
		container.find('li').each(function () {
			if (!$(this).is(':visible')) {
				result.push($(this));
			}
		});

		if (result.length > 0) {
			return false;
		} else {
			return true;
		}
	}

	function resetPaginationParams($clearProducts) {
		$currentPage = 1;
		$('#currentPage').val(1);
		if ($clearProducts) {
			$('.products li').remove();
		}
	}

	//@Todo debug and understand why some products are not getting the data-page attribute
	//@TODO remover função repetida em outro JS (refatorar)
	function fixProductPagination($producCard){
		if (($producCard).attr('data-page') == ''){
			$producCard.attr('data-page',2);
		}
	}

	/**
	 * Order the product-card-featured first, by popularity, then, all those small cards
	 */
	//@TODO remover função repetida em outro JS (refatorar)


	function reorderProducts(){
		let AllProducts = $('li.product-card');

		AllProducts.each(function(){
			fixProductPagination($(this));
			let isProductFeatured = $(this).hasClass('product-featured');
			if (!isProductFeatured) {
				$('.products').attr('visibility','hidden').append($(this));
			}
			else{
				$(this).show().attr('visibility','visible');
			}
		});
	}

	function fetchResults( categories, typeproductid, filtering = false ) {
		/**
		 * Ajax
		 */

		resetPaginationParams();

		$.ajax({
			url: IntegracaoFilter.ajax_url,
			type: 'POST',
			data: {
				action: IntegracaoFilter.action,
				page: 1,
				posts_per_page: -1,
				categories: categories,
				typeproductid: typeproductid,
				nonce: IntegracaoFilter.nonce,
				city: $('#filters-city').val(),
				date1: $('#filter-date-1').val(),
				date2: $('#filter-date-2').val(),
				categoryactual: $('#categoria-atual').val(),
			},
			beforeSend: function() {
				$( $container ).prepend( '<div class="loader"><div class="box1"></div><div class="box2"></div><div class="box3"></div></div>' );
			},
			success: function( result ) {
				if ( result.success ) {
					page++;

					if ( filtering ) {
						$( $container ).empty();
					}

					$( $container ).append( result.data );
					reorderProducts();

					// Valida se existem product featured repetidas após o ajax na página de archive produto (ex: escolas/lideranca)
					for (var i = 0; i < 10; i++) {
						for(var j = 1; j < 10; j++) {
							if($('.product-featured:eq('+ i +')').find('h2').text() == $('.product-featured:eq('+ j +')').find('h2').text()){
								if(j != i){
									$('.product-featured:eq('+ j +')').hide();
								}
							}
						}
					 }

				}
			},
			complete: function() {
				loading = false;
				$( '.loader' ).remove();
				$isAllProductVisible = isAllProductsVisible($container);
			},
			error: function( result ){
					$( $container ).empty();
					$( $container ).append( result.data );
			}
		});
	}
}
infiniteScroll();
